import { render, staticRenderFns } from "./noResultsOffer.vue?vue&type=template&id=bb1d48a6&"
import script from "./noResultsOffer.vue?vue&type=script&lang=js&"
export * from "./noResultsOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports